<div class="app-table-wrapper">
  <ng-container *ngIf="isLoading; else loadedview">
    <div class="app-table-inital-loading-container">
      <app-loading-dots size="5px"></app-loading-dots>
    </div>
  </ng-container>
  <ng-template #loadedview>
    <div
      class="app-table-top-row"
      *ngIf="canSearch || showPaginator || createText || customCountLabel">
      <div class="app-table-searchs-container">
        <ng-content select="[table-top-row-left]"></ng-content>
        <ng-content select="[table-search]"></ng-content>
        <div
          class="app-table-search-container"
          *ngIf="canSearch || showPaginator || customCountLabel">
          <div
            class="inline-label"
            *ngIf="canSearch && searchByOptions?.length">
            <label class="table-header app-label app-label-table">{{
              'search_by' | translation
            }}</label>

            <p-select
              [(ngModel)]="searchBy"
              [options]="searchByOptions || []"
              optionLabel="translation_key"
              optionValue="value"
              [placeholder]="'search_by' | translation"
              style="width: 120px"
              (onChange)="handleUpdateSearchBy($event)">
              <ng-template #selectedItem let-selectedOption>
                {{
                  selectedOption.translation_key || selectedOption.label
                    | translation
                    | transformText: 'capitalize'
                }}
              </ng-template>

              <ng-template let-op #item>
                {{
                  op.translation_key || op.label
                    | translation
                    | transformText: 'capitalize'
                }}
              </ng-template>
            </p-select>
          </div>
          <div class="app-table-search-field" *ngIf="canSearch">
            <p-inputgroup>
              <input
                class="app-table-search-input"
                (keyup.enter)="handleInitSearch()"
                pInputText
                [placeholder]="'search' | translation"
                type="text"
                [(ngModel)]="filterInput" />
              <p-inputgroup-addon *ngIf="filterInput">
                <p-button
                  [variant]="'text'"
                  severity="contrast"
                  (click)="handleInitSearch(true)"
                  type="button"
                  [pTooltip]="'clear_search' | translation"
                  tooltipPosition="top">
                  <i class="fa-thin fa-xmark"></i>
                </p-button>
              </p-inputgroup-addon>
              <p-inputgroup-addon>
                <p-button
                  [variant]="'text'"
                  severity="contrast"
                  (click)="handleInitSearch()"
                  type="button">
                  <i class="fa-thin fa-magnifying-glass"></i>
                </p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <ng-content select="[additional-filters]"></ng-content>

          <span
            [style.color]="'#747d88'"
            *ngIf="customCountLabel"
            class="app-table-top-row-count-label"
            >{{ customCountLabel }}</span
          >

          <div *ngIf="showPaginator" class="app-table-item-per-page-container">
            <label class="app-label app-label-table"
              >{{ 'items_per_page' | translation }}:</label
            >
            <p-select
              [(ngModel)]="perPage"
              [options]="
                perPageOptions || [{ count: 10 }, { count: 25 }, { count: 50 }]
              "
              optionLabel="count"
              optionValue="count"
              [placeholder]="'per_page' | translation"
              (onChange)="handleSetPageCount($event)">
            </p-select>
          </div>
          <span
            *ngIf="itemCount && showPaginator"
            class="app-table-top-row-count-label"
            >{{ getCountLabel() }}</span
          >
        </div>
        <ng-content select="[table-top-row-right]"></ng-content>
      </div>
      <div
        class="app-table-add-button-wrapper"
        *ngIf="createText && showCreate">
        <p-button
          [variant]="'text'"
          severity="text"
          (click)="handleCreateClicked()"
          class="app-table-add-button">
          <i class="fa fa-plus"></i>
          <div class="button-content">{{ createText | translation }}</div>
        </p-button>
      </div>
    </div>

    <!-- {{'course_title'|translation}} -->

    <ng-container *ngIf="!rows?.length && emptyText; else tableview">
      <label style="text-align: center; display: block; padding: 3rem">{{
        emptyText
      }}</label>
    </ng-container>
    <ng-template #tableview>
      <div class="loading-table-wrapper">
        <div
          class="loading-table-overlay-spinner-container"
          *ngIf="isProcessing">
          <app-loading-dots size="5px"></app-loading-dots>
        </div>
        <div [ngClass]="{ 'loading-table-overlay': isProcessing }">
          <div
            class="app-table-container"
            [style.max-height]="maxHeight"
            [style.overflow-y]="'auto'">
            <!-- use virtual scroll table-->
            <ng-container *ngIf="shouldUseVirtualScroll; else noVirtualScroll">
              <cdk-virtual-scroll-viewport
                #scrollViewport
                [itemSize]="44"
                [minBufferPx]="500"
                [maxBufferPx]="1000"
                class="virtual-scroll-viewport"
                [style.height]="getVirtualHeight()">
                <table
                  #table
                  [style.opacity]="hasSetHeaders ? '1' : '0'"
                  [style.visibility]="hasSetHeaders ? 'visible' : 'hidden'"
                  [style.width]="
                    tableLayout === 'fixed' &&
                    hasSetHeaders &&
                    calculatedTableWidthPx
                      ? calculatedTableWidthPx
                      : tableWidth
                  "
                  [style.min-width]="minWidth"
                  [style.table-layout]="tableLayout"
                  class="app-table"
                  [ngClass]="{
                    'app-table-alternating-rows-enabled': hasAlternatingRows,
                    'app-table-bordered': hasBorders,
                    'app-table-borderless': !hasBorders,
                    'headers-calculating': !hasSetHeaders,
                  }">
                  <ng-container
                    *ngTemplateOutlet="tableHeaderTemplate"></ng-container>

                  <tbody>
                    <tr
                      *cdkVirtualFor="
                        let row of rows;
                        trackBy: trackByFn;
                        index as i
                      "
                      (click)="handleClickedRow($event, row)"
                      [style.cursor]="clickableRows ? 'pointer' : 'default'"
                      [ngClass]="{ 'table-link-row': !!clickableRows }"
                      [ngStyle]="row?.rowStyles">
                      <!-- (mousedown)="handleClickedRow($event, row)" -->

                      <ng-container
                        *ngTemplateOutlet="
                          tableRowTemplate;
                          context: { $implicit: row, index: i }
                        "></ng-container>
                    </tr>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </ng-container>
            <!-- avoid virtual scroll table -->

            <ng-template #noVirtualScroll>
              <table
                #table
                [style.width]="
                  tableLayout === 'fixed' &&
                  hasSetHeaders &&
                  calculatedTableWidthPx
                    ? calculatedTableWidthPx
                    : tableLayout === 'fixed' && draggable
                      ? 'auto'
                      : tableWidth
                "
                [style.min-width]="minWidth"
                [style.table-layout]="tableLayout"
                class="app-table"
                [ngClass]="{
                  'app-table-alternating-rows-enabled': hasAlternatingRows,
                  'app-table-bordered': hasBorders,
                  'app-table-borderless': !hasBorders,
                }">
                <ng-container
                  *ngTemplateOutlet="tableHeaderTemplate"></ng-container>

                <tbody>
                  <ng-container
                    *ngFor="let row of rows; trackBy: trackByFn; index as i">
                    <tr
                      (click)="handleClickedRow($event, row)"
                      [style.cursor]="clickableRows ? 'pointer' : 'default'"
                      [ngClass]="{ 'table-link-row': !!clickableRows }"
                      [ngStyle]="row?.rowStyles">
                      <ng-container
                        *ngTemplateOutlet="
                          tableRowTemplate;
                          context: { $implicit: row, i }
                        "></ng-container>
                    </tr>
                  </ng-container>
                </tbody></table
            ></ng-template>
          <div
            *ngIf="shouldShowLoadMore"
            class="load-more-container"
            style="
              padding: 10px 0px 10px 0px;
              display: flex;
              justify-content: center;
            ">
            <app-button
              [isProcessing]="isProcessing"
              [disabled]="disableLoadMore"
              (click)="handleLoadMore()"
              class="load-more-button">
              {{ 'load_more' | translation }}
            </app-button>
          </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-template>
  <scaffold-paginator
    *ngIf="(showPaginator || canSearch) && itemCount > 0"
    [itemCount]="itemCount"
    [(activePage)]="pageNumber"
    [perPage]="perPage"
    [disabled]="isLoading || isProcessing"
    (activePageChange)="handleActivePageChange($event)">
  </scaffold-paginator>
  <!-- Custom row menu overlay: first click works and closes on outside click -->
  <div
    *ngIf="openedRowForMenu && rowMenuItems?.length"
    class="app-table-row-menu-overlay"
    [style.top.px]="rowMenuOverlayTop"
    [style.left.px]="rowMenuOverlayLeft"
    (click)="$event.stopPropagation()">
    <button
      *ngFor="let item of getRowMenuOverlayItems()"
      type="button"
      class="app-table-row-menu-overlay-item"
      [disabled]="item.disabled"
      [attr.title]="
        item.disabled && item.disabledText ? item.disabledText : undefined
      "
      (mousedown)="
        $event.preventDefault();
        $event.stopPropagation();
        !item.disabled && handleRowMenuAction(item.action, openedRowForMenu)
      ">
      {{ item.label }}
    </button>
  </div>
</div>

<!--  table header -->
<ng-template #tableHeaderTemplate>
  <thead>
    <tr>
      <th
        [style.top]="inverseOfTranslation"
        *ngIf="showRowCountColumn"
        [style.width]="'40px'"></th>

      <th
        [style.text-align]="column?.headerTextAlign"
        [style.top]="inverseOfTranslation"
        (click)="handleSortChange(column)"
        *ngFor="let column of columns; trackBy: trackByColumn"
        [style.cursor]="column?.isSortable ? 'pointer' : ''"
        [pTooltip]="column?.headerTooltip"
        [tooltipPosition]="'bottom'">
        <span
          *ngIf="!column.avoidTranslation"
          [style.width]="'100%'"
          [style.text-transform]="column.textTransform"
          [ngClass]="{
            'header-column-checkbox':
              column?.headerCheckboxValue ||
              column?.headerCheckboxValue === false,
          }">
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
            "
            *ngIf="
              column?.headerCheckboxValue ||
              column?.headerCheckboxValue === false
            "
            (click)="$event.stopPropagation()">
            <p-checkbox
              binary="true"
              class="background-color-secondary app-table-checkbox"
              [ngModel]="column.headerCheckboxValue"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="handleCheckedColumn(column)"></p-checkbox>
          </div>
          {{
            column?.translationKey || column.text
              | translation
              | translationFromString
              | transformText: column?.textTransform
          }}
          <span
            style="padding-left: 8px"
            *ngIf="column.isSortable && sortBy === column.property">
            <i
              class="fas text-link-color"
              [ngClass]="{
                'fa-caret-down': sortAsc,
                'fa-caret-up': !sortAsc,
              }">
            </i>
          </span>
          <span
            style="padding-left: 8px"
            *ngIf="column.isSortable && sortBy !== column.property">
            <i class="fas fa-caret-down"> </i>
          </span>
        </span>

        <span
          *ngIf="column.avoidTranslation"
          [style.text-transform]="column.textTransform">
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
            "
            *ngIf="
              column?.headerCheckboxValue ||
              column?.headerCheckboxValue === false
            "
            (click)="$event.stopPropagation()">
            <p-checkbox
              binary="true"
              class="background-color-secondary app-table-checkbox"
              [ngModel]="column.headerCheckboxValue"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="handleCheckedColumn(column)"></p-checkbox>
          </div>
          {{
            column?.translationKey || column.text
              | translation
              | translationFromString
              | transformText: column?.textTransform
          }}
          <span
            style="padding-left: 8px"
            *ngIf="column.isSortable && sortBy === column.property">
            <i
              class="fas text-link-color"
              [ngClass]="{
                'fa-caret-down': sortAsc,
                'fa-caret-up': !sortAsc,
              }">
            </i>
          </span>
          <span
            style="padding-left: 8px"
            *ngIf="column.isSortable && sortBy !== column.property">
            <i class="fas fa-caret-down"> </i>
          </span>
        </span>
        <!-- left -->
        <!-- <div
          class="app-table-resize-column-left-handle"
          (mousedown)="onColumnMouseDown($event, column)"
        ></div> -->
        <!-- right -->
        <div
          *ngIf="draggable"
          class="app-table-resize-column-right-handle"
          (mousedown)="onColumnMouseDown($event, column)"></div>
      </th>
      <th
        [style.top]="inverseOfTranslation"
        class="app-table-header-actions"
        *ngIf="actions?.length || rowMenuItems?.length"></th>
    </tr>
  </thead>
</ng-template>

<!-- table row content -->
<ng-template #tableRowTemplate let-row let-index="index">
  <td *ngIf="showRowCountColumn">
    <div class="app-table-content-wrapper" [style.max-height]="rowMaxHeight">
      {{ index + 1 }}
    </div>
  </td>

  <td
    (click)="copyCellContent($event, row, column)"
    *ngFor="let column of columns; trackBy: trackByColumn"
    [ngSwitch]="column?.type">
    <!-- avoid content for empty rows -->
    <!-- <ng-container *ngIf="row?.emptyRow; else defaultview"></ng-container> -->
    <!-- <ng-template #defaultview> -->
    <!-- dragable row space -->
    <div
      *ngIf="draggable"
      class="app-table-row-drag-top"
      (mousedown)="onRowMouseDown($event)"></div>
    <!-- <div
      *ngIf="tableLayout !== 'auto'"
      class="app-table-row-drag-left"
      (mousedown)="onRowColumnMouseDown($event, column)"
    ></div> -->
    <div
      *ngIf="tableLayout !== 'auto' && draggable"
      class="app-table-row-drag-right"
      (mousedown)="onRowColumnMouseDown($event, column)"></div>

    <div
      *ngIf="!row?.['_avoid_' + column.property]"
      class="app-table-content-wrapper"
      [style.max-width]="rowMaxWidth"
      [style.max-height]="rowMaxHeight">
      <!-- [style.white-space]="column?.whitespace || 'inherit'" -->
      <ng-container *ngSwitchCase="'button-link'">
        <span
          (click)="handleColumnRowClicked($event, row, column.property)"
          class="app-table-button-link text-link-color">
          {{ row?.[column?.property]?.text }}
        </span>
      </ng-container>
      <!-- start row specific template -->
      <ng-container *ngSwitchCase="'template'">
        <!-- failed attempt, will retry with passing in dynamic templates/components/content passed in from parent component to have more control of what each column/rows display, until then, will just have rows provide the dynamic value for what elements to provide for rather than just the columns setting that... -->

        <ng-container [ngSwitch]="row?.[column?.property]?.viewType">
          <ng-container *ngSwitchCase="'button-link'">
            <span
              (click)="handleColumnRowClicked($event, row, column.property)"
              class="app-table-button-link text-link-color">
              {{ row?.[column?.property]?.text }}
            </span>
          </ng-container>

          <ng-container *ngSwitchCase="'locallink'">
            <ng-container
              *ngIf="
                (row?.[column?.property]?.link ||
                  row?.[column?.property]?.text) &&
                  row?.[column?.property]?.text !== column?.defaultValueText;
                else undefinedValue
              ">
              <a
                [escape]="false"
                [pTooltip]="
                  row?.[column.property]?.tooltip
                    | truncate: 400
                    | sanitizeHtmlTooltip
                "
                tooltipPosition="top"
                [queryParams]="row?.[column?.property]?.queryParams"
                [routerLink]="row?.[column?.property]?.link"
                *ngIf="row?.[column?.property]?.link"
                >{{ row?.[column?.property]?.text }}</a
              >
              <ng-container *ngIf="!row?.[column?.property]?.link">{{
                row?.[column?.property]?.text || undefinedText
              }}</ng-container>
            </ng-container>
            <ng-template #undefinedValue>
              <span
                class="app-table-undefined-content"
                [ngClass]="{
                  'app-table-td-content-grey':
                    column?.defaultValueStyleGrey ||
                    row?.[column?.property]?.text === column?.defaultValueText,
                  'app-table-td-content-italic':
                    column?.defaultValueStyleItalic ||
                    row?.[column?.property]?.text === column?.defaultValueText,
                }"
                >{{
                  column?.defaultValueText || undefinedText | translation
                }}</span
              >
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchCase="'date'">
            <ng-container
              *ngIf="
                row?.[column?.property]?.value &&
                  row?.[column?.property]?.value !== column?.defaultValueText;
                else undefinedValue
              ">
              {{
                row?.[column?.property].value
                  | date: 'MMMM d, y'
                  | translationDate
              }}</ng-container
            >
            <ng-template #undefinedValue>
              <span
                class="app-table-undefined-content"
                [ngClass]="{
                  'app-table-td-content-grey':
                    column?.defaultValueStyleGrey ||
                    row?.[column?.property]?.value === column?.defaultValueText,
                  'app-table-td-content-italic':
                    column?.defaultValueStyleItalic ||
                    row?.[column?.property]?.value === column?.defaultValueText,
                }"
                >{{
                  column?.defaultValueText || undefinedText | translation
                }}</span
              >
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchDefault>
            {{ row?.[column?.property]?.text }}</ng-container
          >
        </ng-container>
        <!-- end row specific template -->
      </ng-container>
      <ng-container *ngSwitchCase="'fileSize'">
        <ng-container
          *ngIf="
            row?.[column?.property] !== null &&
              row?.[column?.property] !== undefined &&
              row?.[column?.property] !== column?.defaultValueText;
            else undefinedValue
          ">
          <span>{{ row?.[column?.property] | tableFileSize }}</span>
        </ng-container>

        <ng-template #undefinedValue>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property] === column?.defaultValueText,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property] === column?.defaultValueText,
            }"
            >{{ column?.defaultValueText || undefinedText | translation }}</span
          >
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'number'">
        <ng-container
          *ngIf="
            row?.[column?.property] !== null &&
              row?.[column?.property] !== undefined &&
              row?.[column?.property] !== column?.defaultValueText;
            else undefinedValue
          ">
          <span>{{ row?.[column?.property] | number }}</span>
        </ng-container>

        <ng-template #undefinedValue>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property] === column?.defaultValueText,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property] === column?.defaultValueText,
            }"
            >{{ column?.defaultValueText || undefinedText | translation }}</span
          >
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'textarea'">
        <app-input-textarea
          [customErrorMessages]="column?.customErrorMessages"
          [showErrorAsTooltip]="true"
          [hideErrorContent]="true"
          style="width: 100%"
          [disabled]="cellInputsDisabled"
          [control]="row?.[column?.property]"></app-input-textarea>
      </ng-container>
      <ng-container *ngSwitchCase="'input'">
        <app-input
          [customErrorMessages]="column?.customErrorMessages"
          [showErrorAsTooltip]="true"
          [hideErrorContent]="true"
          style="width: 100%"
          [disabled]="cellInputsDisabled"
          [control]="row?.[column?.property]"></app-input>
      </ng-container>

      <ng-container *ngSwitchCase="'toggle'">
        <div style="display: flex; justify-content: center">
          <app-input-toggle-small
            [escape]="false"
            [pTooltip]="column?.tooltip | truncate: 200 | sanitizeHtmlTooltip"
            tooltipPosition="top"
            (changeUpdate)="handleRowInputUpdate($event, 'toggle', row, column)"
            [control]="row?.[column?.property]"></app-input-toggle-small>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'boolean'">{{
        row?.[column?.property] ? 'Yes' : 'No'
      }}</ng-container>
      <ng-container *ngSwitchCase="'custom'">
        <ng-container
          *ngIf="
            column?.template || cellTemplates?.[column?.property] as cellTpl
          ">
          <ng-container
            *ngTemplateOutlet="
              cellTpl;
              context: {
                $implicit: row,
                row,
                column,
                value:
                  row?.[column?.property]?.value ?? row?.[column?.property],
              }
            "></ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'date'">
        <ng-container
          *ngIf="
            row?.[column?.property] &&
              row?.[column?.property] !== undefinedText &&
              row?.[column?.property] !== column?.defaultValueText;
            else undefinedValue
          ">
          <span>
            {{
              row?.[column?.property]
                | localizeDate: 'MMMM d, yyyy'
                | translationDate
            }}
          </span>
        </ng-container>
        <ng-template #undefinedValue>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property] === column?.defaultValueText,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property] === column?.defaultValueText,
            }"
            >{{
              column?.defaultValueText || column?.undefinedText || undefinedText
                | translation
            }}</span
          >
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'fulldate'">
        <ng-container
          *ngIf="
            row?.[column?.property] &&
              row?.[column?.property] !== column?.defaultValueText;
            else undefinedValue
          ">
          {{
            row?.[column?.property]
              | localizeDate: 'MMMM d, y h:mm:ss a'
              | translationDate
          }}
        </ng-container>
        <ng-template #undefinedValue>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property] === column?.defaultValueText,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property] === column?.defaultValueText,
            }"
            >{{
              column?.defaultValueText || column?.undefinedText || undefinedText
                | translation
            }}</span
          >
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'scaffoldlink'">
        <a
          [style.text-decoration]="'underline'"
          (click)="handleScaffoldLink($event, row, column?.property)"
          [href]="getURL(row)"
          >{{ row?.[column?.property] }}</a
        >
      </ng-container>

      <ng-container *ngSwitchCase="'locallink'">
        <ng-container
          *ngIf="
            (row?.[column?.property]?.link || row?.[column?.property]?.text) &&
              row?.[column?.property]?.text !== column?.defaultValueText;
            else undefinedValue
          ">
          <a
            appTextOverflow
            [tooltipEvent]="
              row?.[column?.property]?.tooltip ||
              row?.[column?.property]?.isTextOverflowed
                ? 'hover'
                : 'noop'
            "
            (overflowed)="handleTextOverflowed(row, column, $event)"
            [escape]="false"
            [pTooltip]="
              row?.[column?.property]?.tooltip
                | truncate: 400
                | sanitizeHtmlTooltip
            "
            tooltipPosition="top"
            [queryParams]="row?.[column?.property]?.queryParams"
            [routerLink]="row?.[column?.property]?.link"
            *ngIf="row?.[column?.property]?.link"
            style="
              display: inline-block;
              max-width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            >{{ row?.[column?.property]?.text }}</a
          >
          <ng-container *ngIf="!row?.[column?.property]?.link">{{
            row?.[column?.property]?.text ||
              column?.undefinedText ||
              undefinedText
          }}</ng-container>
        </ng-container>
        <ng-template #undefinedValue>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property]?.text === column?.defaultValueText,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property]?.text === column?.defaultValueText,
            }"
            >{{
              column?.defaultValueText || column?.undefinedText || undefinedText
                | translation
            }}</span
          >
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'locallinks'">
        <ng-container
          *ngIf="
            row?.[column?.property]?.value.length > 0;
            else undefinedValue
          ">
          <div class="locallinks-container" #locallinksContainer>
            <ng-container
              *ngIf="
                row?.[column.property]?.value.length === 1;
                else multipleLinks
              ">
              <!-- Single link - show full width without truncation -->
              <a
                [escape]="false"
                [pTooltip]="
                  row?.[column.property]?.value[0]?.tooltip
                    | truncate: 400
                    | sanitizeHtmlTooltip
                "
                tooltipPosition="top"
                target="_blank"
                class="locallink-item single-link"
                [routerLink]="row?.[column.property]?.value[0]?.link"
                >{{ row?.[column.property]?.value[0]?.text }}</a
              >
            </ng-container>

            <ng-template #multipleLinks>
              <!-- Multiple links - use smart display logic -->
              <ng-container
                *ngFor="
                  let link of getVisibleLinks(
                    row?.[column.property]?.value,
                    locallinksContainer,
                    row,
                    column
                  );
                  let i = index
                ">
                <a
                  [escape]="false"
                  [pTooltip]="
                    link?.tooltip | truncate: 400 | sanitizeHtmlTooltip
                  "
                  tooltipPosition="top"
                  target="_blank"
                  class="locallink-item"
                  [class.truncated]="link?.needsTruncation"
                  [routerLink]="link?.link"
                  >{{ link?.text }}</a
                >
              </ng-container>

              <span
                class="overflow-count"
                *ngIf="
                  getHiddenCount(
                    row?.[column.property]?.value,
                    locallinksContainer,
                    row,
                    column
                  ) > 0
                "
                [escape]="false"
                [pTooltip]="
                  getOverflowTooltip(
                    row?.[column.property]?.value,
                    locallinksContainer,
                    row,
                    column
                  )
                    | truncate: 400
                    | sanitizeHtmlTooltip
                "
                [attr.data-count]="
                  getHiddenCount(
                    row?.[column.property]?.value,
                    locallinksContainer,
                    row,
                    column
                  )
                ">
                +{{
                  getHiddenCount(
                    row?.[column.property]?.value,
                    locallinksContainer,
                    row,
                    column
                  )
                }}
              </span>
            </ng-template>
          </div>
        </ng-container>
        <ng-template #undefinedValue>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property]?.value?.length === 0,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property]?.value?.length === 0,
            }"
            >{{
              column?.defaultValueText || column?.undefinedText || undefinedText
                | translation
            }}</span
          >
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'link'">
        <ng-container
          *ngIf="
            (row?.[column?.property]?.link || row?.[column?.property]?.text) &&
              row?.[column?.property]?.text !== column?.defaultValueText;
            else undefinedValue
          ">
          <a
            *ngIf="
              row?.[column?.property]?.link && row?.[column?.property]?.text;
              else textcontent
            "
            target="_blank"
            [href]="row?.[column?.property]?.link"
            >{{
              row?.[column?.property]?.text || row?.[column?.property]?.link
            }}
          </a>

          <ng-template #textcontent>
            <span *ngIf="row?.[column?.property]?.text; else nocontent"></span>
            {{ row?.[column?.property]?.text }}

            <ng-template #nocontent>
              <span
                class="app-table-undefined-content"
                [ngClass]="{
                  'app-table-td-content-grey':
                    column?.defaultValueStyleGrey ||
                    row?.[column?.property]?.text === column?.defaultValueText,
                  'app-table-td-content-italic':
                    column?.defaultValueStyleItalic ||
                    row?.[column?.property]?.text === column?.defaultValueText,
                }"
                >{{
                  column?.defaultValueText ||
                    column?.undefinedText ||
                    undefinedText | translation
                }}</span
              >
            </ng-template>
          </ng-template>
        </ng-container>
        <ng-template #undefinedValue>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property]?.text === column?.defaultValueText,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property]?.text === column?.defaultValueText,
            }"
            >{{
              column?.defaultValueText || column?.undefinedText || undefinedText
                | translation
            }}</span
          >
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'checkbox'">
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
          "
          (click)="$event?.stopPropagation()"
          [pTooltip]="
            column?.cellTooltipProperty
              ? row?.[column?.cellTooltipProperty]
              : undefined
          "
          [tooltipDisabled]="
            !column?.cellTooltipProperty ||
            !row?.[column?.cellTooltipProperty]
          "
          tooltipPosition="top">
          <p-checkbox
            [disabled]="cellInputsDisabled || row?.[column?.property]?.disabled"
            binary="true"
            class="background-color-secondary app-table-checkbox"
            [ngModel]="
              row?.[column?.property]?.value ?? row?.[column?.property]
            "
            [ngModelOptions]="{ standalone: true }"
            (onChange)="handleCheckedRow(row, column)"></p-checkbox>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'textIcon'">
        <ng-container
          *ngIf="
            row?.[column?.property] &&
              row?.[column?.property]?.text !== column?.defaultValueText;
            else undefinedConetnt
          ">
          <span>{{
            row?.[column?.property]?.text || column?.undefinedText
          }}</span>
          <i
            style="padding: 0px 10px"
            *ngIf="row?.[column?.property]?.iconClass"
            [ngClass]="row?.[column?.property]?.iconClass"
            [escape]="false"
            [pTooltip]="
              row?.[column?.property]?.tooltip
                | truncate: 400
                | sanitizeHtmlTooltip
            "></i>
        </ng-container>
        <ng-template #undefinedConetnt>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property]?.text === column?.defaultValueText,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property]?.text === column?.defaultValueText,
            }"
            >{{
              column?.defaultValueText || column?.undefinedText || undefinedText
            }}</span
          >
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'html'">
        <ng-container
          *ngIf="
            row?.[column?.property] &&
              row?.[column?.property] !== column?.defaultValueText;
            else undefinedValue
          ">
          <span
            [ngClass]="
              column?.getClass ? column?.getClass(row?.[column?.property]) : ''
            "
            [style.max-width]="
              column?.maxLengthEllipse === 'auto'
                ? '100%'
                : column?.maxLengthEllipse || 'none'
            "
            [style.overflow]="column?.maxLengthEllipse ? 'hidden' : 'visible'"
            [style.text-overflow]="
              column?.maxLengthEllipse ? 'ellipsis' : 'clip'
            "
            [style.white-space]="column?.maxLengthEllipse ? 'nowrap' : 'normal'"
            [style.display]="column?.maxLengthEllipse ? 'block' : 'inline'"
            [escape]="false"
            [pTooltip]="
              column?.maxLengthEllipse && column?.hasMaxLengthEllipseTooltip
                ? ((column?.tooltipProperty
                    ? row?.[column?.tooltipProperty]
                    : row?.[column?.property]
                  )
                  | truncate: 400
                  | sanitizeHtmlTooltip)
                : ''
            "
            tooltipPosition="top"
            [innerHTML]="row?.[column?.property] | safeHtml"></span>
        </ng-container>
        <ng-template #undefinedValue>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property] === column?.defaultValueText,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property] === column?.defaultValueText,
            }"
            >{{
              column?.defaultValueText || column?.undefinedText || undefinedText
                | translation
            }}</span
          >
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'string'">
        <ng-container
          *ngIf="
            (row?.[column?.property] || row?.[column?.property] === 0) &&
              row?.[column?.property] !== column?.defaultValueText;
            else undefinedValue
          ">
          <span
            [ngClass]="
              column?.getClass ? column?.getClass(row?.[column?.property]) : ''
            "
            [style.max-width]="
              column?.maxLengthEllipse === 'auto'
                ? '100%'
                : column?.maxLengthEllipse || 'none'
            "
            [style.overflow]="column?.maxLengthEllipse ? 'hidden' : 'visible'"
            [style.text-overflow]="
              column?.maxLengthEllipse ? 'ellipsis' : 'clip'
            "
            [style.white-space]="column?.maxLengthEllipse ? 'nowrap' : 'normal'"
            [style.display]="column?.maxLengthEllipse ? 'block' : 'inline'"
            [escape]="false"
            [pTooltip]="
              column?.maxLengthEllipse && column?.hasMaxLengthEllipseTooltip
                ? ((column?.tooltipProperty
                    ? row?.[column?.tooltipProperty]
                    : row?.[column?.property]
                  )
                  | showFalsy
                  | truncate: 400
                  | sanitizeHtmlTooltip)
                : ('' | truncate: 400 | sanitizeHtmlTooltip)
            "
            tooltipPosition="top"
            >{{ row?.[column?.property] | showFalsy }}</span
          >
        </ng-container>

        <ng-template #undefinedValue>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property] === column?.defaultValueText,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property] === column?.defaultValueText,
            }"
            >{{
              column?.defaultValueText || column?.undefinedText || undefinedText
                | translation
            }}</span
          >
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <ng-container
          *ngIf="
            (row?.[column?.property] || row?.[column?.property] === 0) &&
              row?.[column?.property] !== column?.defaultValueText;
            else undefinedValue
          ">
          <span
            [ngClass]="
              column?.getClass ? column?.getClass(row?.[column?.property]) : ''
            "
            [style.max-width]="
              column?.maxLengthEllipse === 'auto'
                ? '100%'
                : column?.maxLengthEllipse || 'none'
            "
            [style.overflow]="column?.maxLengthEllipse ? 'hidden' : 'visible'"
            [style.text-overflow]="
              column?.maxLengthEllipse ? 'ellipsis' : 'clip'
            "
            [style.white-space]="column?.maxLengthEllipse ? 'nowrap' : 'normal'"
            [style.display]="column?.maxLengthEllipse ? 'block' : 'inline'"
            [escape]="false"
            [pTooltip]="
              column?.maxLengthEllipse && column?.hasMaxLengthEllipseTooltip
                ? ((column?.tooltipProperty
                    ? row?.[column?.tooltipProperty]
                    : row?.[column?.property]
                  )
                  | showFalsy
                  | truncate: 400
                  | sanitizeHtmlTooltip)
                : ''
            "
            tooltipPosition="top"
            >{{ row?.[column?.property] | showFalsy }}</span
          >
        </ng-container>

        <ng-template #undefinedValue>
          <span
            class="app-table-undefined-content"
            [ngClass]="{
              'app-table-td-content-grey':
                column?.defaultValueStyleGrey ||
                row?.[column?.property] === column?.defaultValueText,
              'app-table-td-content-italic':
                column?.defaultValueStyleItalic ||
                row?.[column?.property] === column?.defaultValueText,
            }"
            >{{
              column?.defaultValueText || column?.undefinedText || undefinedText
                | translation
            }}</span
          >
        </ng-template>
      </ng-container>
      {{ row?.[column?.property]?.icon }}
      <i
        *ngIf="row?.[column?.property]?.icon"
        [ngClass]="row?.[column?.property]?.icon?.class"
        [escape]="false"
        [pTooltip]="
          row?.[column?.property]?.icon?.tooltip
            | truncate: 400
            | sanitizeHtmlTooltip
        "
        class="app-table-inline-icon"></i>
    </div>
  </td>
  <td
    class="app-table-cell-actions"
    *ngIf="
      (actions?.length || rowMenuItems?.length) &&
      !row?._avoid_actions &&
      !row?.emptyRow
    ">
    <div class="app-table-actions-container">
      <ng-container
        [ngSwitch]="action.type"
        *ngFor="let action of actions; trackBy: trackByAction">
        <ng-container *ngSwitchCase="'duplicate'">
          <p-button
            *ngIf="!row?.avoid_duplicate"
            [disabled]="row?._is_duplicating || row?._is_disabled"
            [escape]="false"
            [pTooltip]="
              action?.tooltip || action.type
                | translation
                | truncate: 400
                | sanitizeHtmlTooltip
            "
            tooltipPosition="left"
            [variant]="'text'"
            [severity]="'link'"
            (click)="handleActionClicked($event, action.type, row)">
            <i class="fa-thin fa-copy"></i>
          </p-button>
        </ng-container>
        <ng-container *ngSwitchCase="'edit'">
          <p-button
            [disabled]="row?._is_editig || row?._is_disabled"
            [style.visibility]="!row?._avoid_edit ? 'visible' : 'hidden'"
            [escape]="false"
            [pTooltip]="
              action?.tooltip || action.type
                | translation
                | truncate: 400
                | sanitizeHtmlTooltip
            "
            tooltipPosition="left"
            [variant]="'text'"
            [severity]="'link'"
            (click)="handleActionClicked($event, action.type, row)">
            <i class="fa-thin fa-pencil-alt"></i>
          </p-button>
        </ng-container>
        <ng-container *ngSwitchCase="'delete'">
          <p-button
            [disabled]="row?._is_deleting || row?._is_disabled"
            [style.visibility]="!row?.avoid_delete ? 'visible' : 'hidden'"
            [escape]="false"
            [pTooltip]="
              action?.tooltip || action.type
                | translation
                | truncate: 400
                | sanitizeHtmlTooltip
            "
            tooltipPosition="left"
            [variant]="'text'"
            [severity]="'link'"
            (click)="handleActionClicked($event, action.type, row)">
            <i class="fa-thin fa-trash-alt"></i>
          </p-button>
        </ng-container>
        <ng-container *ngSwitchCase="'info'">
          <p-button
            [style.visibility]="!row?.avoid_info ? 'visible' : 'hidden'"
            [escape]="false"
            [pTooltip]="
              action?.tooltip || action.type
                | translation
                | truncate: 400
                | sanitizeHtmlTooltip
            "
            tooltipPosition="left"
            [variant]="'text'"
            [severity]="'link'"
            (click)="handleActionClicked($event, action.type, row)">
            <i class="fa-thin fa-info-circle"></i>
          </p-button>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="rowMenuItems?.length">
        <p-button
          styleClass="app-table-row-menu-trigger"
          [variant]="'text'"
          [severity]="'primary'"
          (click)="openRowMenu($event, row)"
          tooltipPosition="left"
          icon="fa-solid fa-ellipsis">
        </p-button>
      </ng-container>
    </div>
  </td>
</ng-template>
